import React, { useEffect, useState, useMemo } from "react";
import SchedulerCalendar from "../../../components/SchedulerCalendar";
import StickySidebar from "../../../components/StickySidebar";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import OfficeFilter from "../../../components/SchedulerFilters/OfficeFilter";
import { withTranslation } from "react-i18next";
import "./../../../Scheduler.scss";
import schedulerStyles from "../../../Scheduler.module.scss";
import styles from "./AgendaTab.module.scss";
import AgendaDailyView from "./AgendaView/AgendaDailyView";
import AgendaWeeklyView from "./AgendaView/AgendaWeeklyView";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import constants from "../../../../../../constants";
import { isMobileTab, cacheSideBarActive, getStorage, setStorage } from "utils";
import moment from "moment";
import AddToCalendar from "accountOwner/pages/components/AddToCalendar";
import CustomModal from "components/CustomModal";
import {
  getSyncCalendar,
  useAllActiveOffices,
  useGetAgenda,
} from "repositories/scheduler-repository";
import toast from "react-hot-toast";
import Loader from "components/Loader";
import SyncModal from "accountOwner/pages/Scheduler/components/Modals/SyncModal";
import AgendaMonthView from "./AgendaView/AgendaMonthView";
import WeeklyListView from "./AgendaView/WeeklyListView";
import DailyListView from "./AgendaView/DailyListView";
import CustomDropdown from "components/Dropdown";
import AgendaFilter from "accountOwner/pages/Scheduler/components/SchedulerFilters/AgendaFilter";
import {
  filteringMethodForEventShiftOthers,
  leaveClasses,
} from "accountOwner/pages/Scheduler/scheduler.function";
import { showTime } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

function AgendaTab({
  t,
  agendaFiltersData,
  staffAvailabilityViewSelectedFromDashBoard,
  currentDateFromDashBoard,
  setCurrentDateFromDashBoard,
  isFromDashBoard = false,
  appliedAgendaTypes,
  appliedViewSettig,
  isEnterpriseFilterActive,
}) {
  const [toolTipModal, setToolTipModal] = useState(false);
  const [syncModal, setSyncModal] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncUrl, setSyncUrl] = useState(null);

  const preExpanded = useMemo(() => {
    const values = getStorage(
      constants.accordion.cache.schedulermyScheduleEventAccordion,
    );
    if (values) {
      if (Array.isArray(values)) {
        return values;
      }
    }
    return ["a", "b", "c"];
  }, []);

  const {
    effectiveOwnerId: selectedOwnerId,
    profile: { id: currentUserId },
    isStaff,
    effectiveOwnerIdString,
  } = useAccountOwnerCommon();
  const FilterEventsData = [
    { title: t("accountOwner.eventCreatedByYou"), type: 0 }, // here 0 is not a type taking to check user filter by there id
    { title: t("accountOwner.eventCreatedByOthers"), type: -1 }, // here -1 is not a type taking to check user filter by there id
    { title: t("accountOwner.eventsNotAccepted"), type: 4 },
    { title: t("accountOwner.busy"), type: 3 },
    { title: t("accountOwner.shiftCreatedByYou"), type: 8 },
    { title: t("accountOwner.shiftCreatedByOthers"), type: 6 },
    { title: t("accountOwner.shiftNotAccepted"), type: 7 },
    // { title: t('accountOwner.nonAvailableDays'), type: -2 }, // here -2 is not a type taking to check user filter by there id
    { title: t("accountOwner.leaveApproved"), type: 2 },
    { title: t("accountOwner.leavePending"), type: 9 }, // type 9 will be matched with 1 in leave statusId
    { title: t("scheduler.agenda.appointmentTitle"), type: 1 },
  ];

  const ViewSettingFilterBase = [
    { title: t("title"), type: "title" },
    { title: t("waitingList.clinicName"), type: "officeName" },
    { title: t("dateAndTime"), type: "timeString" },
  ];

  let cachedEventFilter = getStorage(
    constants.localStorageKeys.agenda.eventFilter,
  );
  const enterpriseCache = getStorage(
    constants.localStorageKeys.agenda.enterprise,
  );
  cachedEventFilter = cachedEventFilter ? cachedEventFilter : [];

  const cacheDashBoardFilter = getStorage(
    constants.notes.cache.dashboardFilter,
  );

  const agendaEventFilter = cacheDashBoardFilter?.agenda
    ? cacheDashBoardFilter?.agenda
    : [];
  const { search } = useLocation();
  const [currentDate, onDateChange] = useState(() => {
    const searchValue = new URLSearchParams(search).get(showTime);
    if (searchValue?.includes("NaN") || !search) {
      const cached = sessionStorage.getItem(constants.MY_SCHEDULER_EVENT_DATE);
      if (cached) {
        return new Date(cached);
      }
      return new Date();
    }
    return new Date(+searchValue);
  });
  // cachedDate
  const [agenda, setAgenda] = useState(null);
  const [agendaTypes, setAgendaTypes] = useState(cachedEventFilter);
  const [agendaFilter, setAgendaFilter] = useState([]);
  const [viewSettig, setViewSetting] = useState([]);
  const [settingFilter, setSettingFilter] = useState([]);
  const [dateRange, setDateRange] = useState(null);
  // Enterprise event filter states
  const [showEnterpriseEvents, setShowEnterpriseEvents] = useState(
    enterpriseCache ?? false,
  );
  // Applied enterprise filter - only updated when Apply is clicked
  const [appliedEnterpriseFilter, setAppliedEnterpriseFilter] = useState(
    enterpriseCache ?? false,
  );

  const effectiveEnterpriseFilter = isFromDashBoard
    ? isEnterpriseFilterActive
    : appliedEnterpriseFilter;

  useEffect(() => {
    sessionStorage.setItem(
      constants.MY_SCHEDULER_EVENT_DATE,
      moment(currentDate),
    );
  }, [currentDate]);

  const agendaView = [
    { id: "1", name: t("scheduler.views.daily") },
    { id: "2", name: t("scheduler.views.weekly") },
    { id: "3", name: t("scheduler.views.monthly") },
    { id: "4", name: t("scheduler.views.dailyList") },
    { id: "5", name: t("scheduler.views.weeklyList") },
  ];
  const cachedView = sessionStorage.getItem("agendaView") || null;

  const [agendaViewSelected, setAgendaViewSelected] = useState(
    cachedView || agendaView[0].id,
  );

  // For Weekly view (id: "2"), Daily view (id: "1"), Weekly List (id: "5"), and Daily List (id: "4"), only show Clinic name and Title
  const ViewSettingFilter = useMemo(() => {
    if (
      agendaViewSelected === "2" ||
      agendaViewSelected === "1" ||
      agendaViewSelected === "4" ||
      agendaViewSelected === "5"
    ) {
      return ViewSettingFilterBase.filter(
        (item) => item.type === "officeName" || item.type === "title",
      );
    }
    return ViewSettingFilterBase;
  }, [agendaViewSelected, t]);

  useEffect(() => {
    sessionStorage.setItem("agendaView", agendaViewSelected);
  }, [agendaViewSelected]);

  const {
    selectedOfficeFilter,
    setOfficeFilter,
    apiOffices,
    setApiOffices,
    resetFilters: resetAgendaFilters,
    appliedOfficeFilter,
    setAppliedOfficeFilter,
  } = agendaFiltersData;

  const [isSidebarActive, setSidebarActive] = useState(
    cacheSideBarActive(constants.sidebar.cache.schedulerIsSidebarActive),
  );

  const handleSidebarToggle = () => {
    setSidebarActive(!isSidebarActive);
    localStorage.setItem(
      constants.sidebar.cache.schedulerIsSidebarActive,
      !isSidebarActive,
    );
  };

  const enableFetch = selectedOwnerId && dateRange ? true : false;
  const {
    isLoading,
    isFetching,
    data: agendaData,
    error,
  } = useGetAgenda(
    selectedOwnerId,
    dateRange?.startDate,
    dateRange?.endDate,
    apiOffices,
    { enabled: enableFetch },
  );

  useEffect(() => {
    if (!isLoading && agendaData?.data) {
      setAgenda(agendaData?.data);
      setAgendaFilter(agendaData?.data);
    }
  }, [isLoading, agendaData]);

  const scrollToElement = () => {
    const element = document.getElementById("targetElementIdForMySchedule");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    }
  };

  const filterByEvents = (enterpriseFilter = effectiveEnterpriseFilter) => {
    const updatedAgenda = agenda?.map((item) => {
      return filteringMethodForEventShiftOthers(
        agendaTypes,
        item,
        currentUserId,
        enterpriseFilter,
      );
    });
    setAgendaFilter(updatedAgenda);
  };

  const resetFilter = () => {
    scrollToElement();
    resetAgendaFilters();
    setAgendaFilter(agenda);
    setAgendaTypes([]);
    setStorage(constants.localStorageKeys.agenda.eventFilter, []);
    setViewSetting([]);
    setSettingFilter([]);
    setStorage(constants.localStorageKeys.agenda.mySettingFilter, []);
    setStorage(constants.localStorageKeys.agenda.enterprise, false);
    setAppliedOfficeFilter([]);
    setOfficeFilter([]);
    setShowEnterpriseEvents(false);
    setAppliedEnterpriseFilter(false);
  };

  useEffect(() => {
    let mySettingFilter = getStorage(
      constants.localStorageKeys.agenda.mySettingFilter,
    );
    let settingFilter = mySettingFilter?.length > 0 ? mySettingFilter : [];
    setViewSetting(settingFilter);
    setSettingFilter(settingFilter);
  }, [agendaViewSelected]);

  const applyFilter = () => {
    scrollToElement();
    setApiOffices(selectedOfficeFilter);
    setAppliedOfficeFilter(selectedOfficeFilter);
    if (isMobileTab() && isSidebarActive && selectedOfficeFilter?.length) {
      handleSidebarToggle();
    }

    // Apply the enterprise filter only when Apply button is clicked
    setAppliedEnterpriseFilter(showEnterpriseEvents);
    setStorage(
      constants.localStorageKeys.agenda.enterprise,
      showEnterpriseEvents,
    );
    if (agendaTypes?.length > 0 || showEnterpriseEvents) {
      if (!isFromDashBoard) {
        // Pass the new filter value directly to ensure it's used immediately
        filterByEvents(showEnterpriseEvents);
      }

      if (agendaTypes?.length > 0) {
        setStorage(constants.localStorageKeys.agenda.eventFilter, agendaTypes);
      }
    } else {
      setAgendaFilter(agenda);
      setStorage(constants.localStorageKeys.agenda.eventFilter, agendaTypes);
    }
    if (viewSettig?.length > 0) {
      setSettingFilter(viewSettig);
      setStorage(constants.localStorageKeys.agenda.mySettingFilter, viewSettig);
    } else {
      setSettingFilter([]);
      setStorage(constants.localStorageKeys.agenda.mySettingFilter, viewSettig);
    }
  };

  const handleAddToCalendar = async () => {
    setSyncLoading(true);
    const isWeekly = agendaViewSelected === "2" || agendaViewSelected === "5";
    const isMonthly = agendaViewSelected === "3";
    let startDate = moment(currentDate).format("YYYY-MM-DD");
    if (isWeekly) {
      if (agendaViewSelected === "2") {
        startDate = moment(currentDate).startOf("week").format("YYYY-MM-DD");
      } else {
        startDate = moment(currentDate).startOf("isoWeek").format("YYYY-MM-DD");
      }
    } else if (isMonthly) {
      startDate = moment(currentDate).startOf("month").format("YYYY-MM-DD");
    }
    try {
      const { data } = await getSyncCalendar(selectedOwnerId, startDate);
      setSyncLoading(false);
      setSyncUrl(data);
      setSyncModal(true);
    } catch (error) {
      toast.error(error.message);
      setSyncLoading(false);
    }
  };

  const dateChange = (type) => {
    let changeDate =
      agendaViewSelected === "1" || agendaViewSelected === "4"
        ? "day"
        : agendaViewSelected === "2" || agendaViewSelected === "5"
          ? "week"
          : "month";
    let date = null;
    if (agendaViewSelected === "1" || agendaViewSelected === "4") {
      date =
        type === constants.arrow.PREVIOUS
          ? new Date(moment(currentDate).subtract(1, changeDate).startOf("day"))
          : new Date(moment(currentDate).add(1, changeDate).startOf("day"));
    }
    if (agendaViewSelected === "2") {
      date =
        type === constants.arrow.PREVIOUS
          ? new Date(
              moment(currentDate).subtract(1, changeDate).startOf("week"),
            )
          : new Date(moment(currentDate).add(1, changeDate).startOf("week"));
    }
    if (agendaViewSelected === "5") {
      date =
        type === constants.arrow.PREVIOUS
          ? new Date(
              moment(currentDate).subtract(1, changeDate).startOf("isoweek"),
            )
          : new Date(moment(currentDate).add(1, changeDate).startOf("isoweek"));
    }
    if (agendaViewSelected === "3") {
      date =
        type === constants.arrow.PREVIOUS
          ? new Date(
              moment(currentDate).subtract(1, changeDate).startOf("month"),
            )
          : new Date(moment(currentDate).add(1, changeDate).startOf("month"));
    }

    date && onDateChange(date);
  };

  const onActiveStartDateChange = (value) => {
    if (
      constants.calanderActions.includes(value?.action) ||
      (value?.action === constants.calanderActionKey.drillDown &&
        (value?.view === "month" || value?.view === "year"))
    ) {
      value?.activeStartDate && onDateChange(value.activeStartDate);
    }
  };

  const syncCalenderText = useMemo(
    () => (
      <>
        <p>
          Syncing the calendar allows you to add all the events showing in the
          Agenda to your personal calendar on the web.
        </p>
        <p>
          You can sync the Scheduler with your personal calendar by following
          the below-mentioned steps:
        </p>
        <ul>
          <li>Click on the Sync link.</li>
          <li>Click on the link to copy the link.</li>
          <li>
            To sync Agenda on Google Calendar, open{" "}
            <a
              href="http://calendar.google.com"
              rel="noreferrer"
              className="link-btn"
              target="_blank"
            >
              calendar.google.com
            </a>{" "}
            on the browser.
          </li>
          <li>Click on Add Calendar + icon on Google Calendar.</li>
          <li>Select "From URL" from the available options.</li>
          <li>Paste the URL that you copied from Agenda.</li>
          <li>Click on the button for "Add Calendar".</li>
        </ul>
        <p>
          Once added, all the events from the Agenda screen will be added to
          Google Calendar. By doing so, whenever a new event is added in the
          Scheduler Agenda, the same will be added in the Google calendar as
          well.
        </p>
        <p>
          You can follow the same steps to sync the Agenda with other calendars
          such as Outlook, Apple Calendar etc.
        </p>
        <p>
          You can also unsubscribe to the calendar to remove the Agenda events
          from your personal calendar.
        </p>
      </>
    ),
    [],
  );

  useEffect(() => {
    if (isFromDashBoard) {
      if (agendaTypes?.length > 0 || effectiveEnterpriseFilter) {
        filterByEvents();
      } else {
        setAgendaFilter(agenda);
      }
    }
  }, [agendaTypes, agenda, isFromDashBoard, effectiveEnterpriseFilter]);

  useEffect(() => {
    if (isFromDashBoard) {
      scrollToElement();
      setAgendaTypes(appliedAgendaTypes);
      setSettingFilter(appliedViewSettig);
    }
  }, [appliedAgendaTypes, appliedViewSettig]);

  useEffect(() => {
    // Only for My Schedule, not Dashboard
    if (!isFromDashBoard) {
      let cachedEventFilter = getStorage(
        constants.localStorageKeys.agenda.eventFilter,
      );
      cachedEventFilter = cachedEventFilter ? cachedEventFilter : [];
      setAgendaTypes(cachedEventFilter);

      // Apply the filter to the data if any filter is present
      if (cachedEventFilter.length > 0 || appliedEnterpriseFilter) {
        setTimeout(() => {
          filterByEvents();
        }, 0);
      } else {
        setAgendaFilter(agenda);
      }
    }
  }, [agendaViewSelected, isFromDashBoard, agenda, appliedEnterpriseFilter]);
  const { data } = useAllActiveOffices(
    1,
    constants.OFFICE_PAGE_SIZE_100,
    {
      includeOwnerOffices: false,
      ownerId: selectedOwnerId,
    },
    "",
    { enabled: !!selectedOwnerId },
  );
  const canShowOfficeName = useMemo(() => data?.data?.length > 1, [data?.data]);
  return (
    <div
      style={isFromDashBoard ? { maxHeight: "428px", height: "100%" } : {}}
      className={
        isFromDashBoard
          ? "scheduler-tabs-main-wrapper agenda-daily-view m-0"
          : "scheduler-tabs-main-wrapper agenda-daily-view"
      }
    >
      {syncLoading && <Loader />}
      {!isFromDashBoard && (
        <StickySidebar
          isSidebarActive={isSidebarActive}
          handleSidebarToggle={handleSidebarToggle}
          resetFilter={resetFilter}
        >
          <SchedulerCalendar
            value={currentDate}
            onChange={onDateChange}
            onActiveStartDateChange={onActiveStartDateChange}
            activeStartDate={currentDate}
            showTodayButton={true}
            onTodayClick={() => {
              onDateChange(new Date());
            }}
          />
          <div className="mb-4">
            <span className={styles.notes_filter}>
              {t("notes.filters")}
              {!!(
                appliedOfficeFilter?.length ||
                cachedEventFilter?.length ||
                settingFilter?.length ||
                appliedEnterpriseFilter
              ) && <span className={styles.red_dot}></span>}
            </span>
            <ul className={["filter-list"]}>
              <li>
                <div className="ch-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={showEnterpriseEvents}
                      onChange={(e) =>
                        setShowEnterpriseEvents(e.target.checked)
                      }
                    />{" "}
                    <span> {t("showEnterpriseEvents")}</span>
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <Accordion
            preExpanded={preExpanded}
            className="filter-accordion"
            allowZeroExpanded
            allowMultipleExpanded
            onChange={(e) => {
              setStorage(
                constants.accordion.cache.schedulermyScheduleEventAccordion,
                e,
              );
            }}
          >
            <AccordionItem uuid="a">
              <AccordionItemHeading>
                <AccordionItemButton>{t("offices")}</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <OfficeFilter
                  selectedOffice={selectedOfficeFilter}
                  setOfficeFilter={setOfficeFilter}
                  selectedOwnerId={selectedOwnerId}
                />
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="b">
              <AccordionItemHeading>
                <AccordionItemButton>
                  {t("accountOwner.filterEvents")}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <AgendaFilter
                  setAgendaTypes={setAgendaTypes}
                  agendaTypes={agendaTypes}
                  FilterEventsData={FilterEventsData}
                />
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="c">
              <AccordionItemHeading>
                <AccordionItemButton>
                  {t("accountOwner.viewSetting")}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <AgendaFilter
                  setAgendaTypes={setViewSetting}
                  agendaTypes={viewSettig}
                  FilterEventsData={ViewSettingFilter}
                />
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <div className="filter-btn-box filter-btn-box--sticky-footer ">
            <button
              className={"button button-round button-shadow mr-3"}
              title={t("apply")}
              onClick={applyFilter}
            >
              {" "}
              {t("apply")}
            </button>
            <button
              className={
                "button button-round button-border button-dark reset-btn "
              }
              title={t("reset")}
              onClick={resetFilter}
            >
              {t("reset")}
            </button>
            <button
              className={
                "button button-round button-border button-dark cancel-btn"
              }
              title={t("close")}
              onClick={handleSidebarToggle}
            >
              {t("close")}
            </button>
          </div>
        </StickySidebar>
      )}
      <div
        className={
          isFromDashBoard ? "tabs-right-col p-0 h-100" : "tabs-right-col h-100"
        }
        id="targetElementIdForMySchedule"
      >
        {!isFromDashBoard && (
          <div className={styles["staff-availability-header"]}>
            <ul className={styles["view-color-list"]}>
              <li>
                <div className={styles["color-box"]} />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("accountOwner.createdByYou")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={styles["color-box"] + " " + styles["color-grey"]}
                />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("accountOwner.createdByOthers")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={styles["color-box"] + " " + styles["color-blue"]}
                />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("accountOwner.eventsNotAccepted")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={styles["color-box"] + " " + styles["color-orange"]}
                />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("accountOwner.busy")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={
                    styles["color-box"] +
                    " " +
                    schedulerStyles[
                      leaveClasses(constants.agendaType.PENDINGLEAVE).main
                    ]
                  }
                />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("scheduler.agenda.pendingLeave")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={
                    styles["color-box"] +
                    " " +
                    schedulerStyles[
                      leaveClasses(constants.agendaType.APPROVEDLEAVE).main
                    ]
                  }
                />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("scheduler.agenda.approvedLeave")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={
                    styles["color-box"] + " " + styles["light-purple-bg"]
                  }
                />
                <div className={styles["text-box"]}> {t("appointments")} </div>
              </li>
            </ul>
            <Link
              to={{
                pathname: constants.routes.scheduler.addBusySlot,
                search: effectiveOwnerIdString
                  ? `?${effectiveOwnerIdString}`
                  : "",
              }}
              className={
                "button button-round button-shadow staff-calendar-select-box " +
                styles.button
              }
            >
              {t("accountOwner.addBusyTimeslots")}
            </Link>
          </div>
        )}
        {!isFromDashBoard && (
          <div className={styles["agenda-header"]}>
            <div>
              <AddToCalendar
                firstIcon={require("assets/images/ico_sync.svg").default}
                middleText={t("accountOwner.sync")}
                secondIcon={require("assets/images/alert-circle.svg").default}
                handleAddToCalendar={handleAddToCalendar}
                setToolTipModal={setToolTipModal}
              />
            </div>
            <div className="d-flex ">
              <div className="monthly-calendar-arrows">
                <div
                  className="arrow-img"
                  onClick={() => dateChange(constants.arrow.PREVIOUS)}
                >
                  <img
                    src={
                      require("assets/images/monthly-arrow-left.svg").default
                    }
                    alt="icon"
                  />
                </div>

                <div className="monthly-calendar-text">
                  {(agendaViewSelected === "1" || agendaViewSelected === "4") &&
                    moment(currentDate).format("ddd, MMM DD, YYYY")}
                  {agendaViewSelected === "3" &&
                    moment(currentDate).format("MMM YYYY")}

                  {agendaViewSelected === "2" && (
                    <>
                      {`${moment(currentDate)
                        .startOf("week")
                        .format("ddd, MMM DD")} - ${moment(currentDate)
                        .endOf("week")
                        .format("ddd, MMM DD")} `}
                    </>
                  )}

                  {agendaViewSelected === "5" && (
                    <>
                      {`${moment(currentDate)
                        .startOf("isoweek")
                        .format("ddd, MMM DD")} - ${moment(currentDate)
                        .endOf("isoweek")
                        .format("ddd, MMM DD")} `}
                    </>
                  )}
                </div>
                <div
                  className="arrow-img"
                  onClick={() => dateChange(constants.arrow.NEXT)}
                >
                  <img
                    src={
                      require("assets/images/monthly-arrow-right.svg").default
                    }
                    alt="icon"
                  />
                </div>
              </div>
              <CustomDropdown
                options={agendaView}
                selectedOption={agendaViewSelected}
                selectOption={setAgendaViewSelected}
              />
            </div>
          </div>
        )}
        {isFromDashBoard ? (
          <>
            {(staffAvailabilityViewSelectedFromDashBoard === "1" ||
              staffAvailabilityViewSelectedFromDashBoard === "4") && (
              <AgendaDailyView
                isSidebarActive={isSidebarActive}
                currentDate={currentDateFromDashBoard}
                currentUserId={currentUserId}
                setCurrentDate={setCurrentDateFromDashBoard}
                isFromDashBoard={isFromDashBoard}
                viewSettingFilter={settingFilter}
                setDateRange={setDateRange}
                agenda={agendaFilter}
                isLoading={isLoading}
                isFetching={isFetching}
                error={error}
                selectedOwnerId={selectedOwnerId}
                isStaff={isStaff}
                isEnterpriseFilterActive={effectiveEnterpriseFilter}
                canShowOfficeName={canShowOfficeName}
              />
            )}
            {staffAvailabilityViewSelectedFromDashBoard === "2" && (
              <AgendaWeeklyView
                isSidebarActive={isSidebarActive}
                currentDate={currentDateFromDashBoard}
                setCurrentDate={onDateChange}
                isWeekly={staffAvailabilityViewSelectedFromDashBoard == "2"}
                currentUserId={currentUserId}
                isFromDashBoard={isFromDashBoard}
                viewSettingFilter={settingFilter}
                setDateRange={setDateRange}
                agenda={agendaFilter}
                isLoading={isLoading}
                isFetching={isFetching}
                error={error}
                selectedOwnerId={selectedOwnerId}
                isStaff={isStaff}
                isEnterpriseFilterActive={effectiveEnterpriseFilter}
                canShowOfficeName={canShowOfficeName}
              />
            )}
            {staffAvailabilityViewSelectedFromDashBoard === "3" && (
              <AgendaMonthView
                currentDate={currentDate}
                setCurrentDate={onDateChange}
                currentUserId={currentUserId}
                viewSettingFilter={settingFilter}
                setDateRange={setDateRange}
                agenda={agendaFilter}
                isLoading={isLoading}
                isFetching={isFetching}
                error={error}
                selectedOwnerId={selectedOwnerId}
                isStaff={isStaff}
                isFromDashBoard={isFromDashBoard}
                isEnterpriseFilterActive={effectiveEnterpriseFilter}
                canShowOfficeName={canShowOfficeName}
              />
            )}
          </>
        ) : (
          <>
            {agendaViewSelected === "4" && (
              <AgendaDailyView
                isSidebarActive={isSidebarActive}
                currentDate={currentDate}
                currentUserId={currentUserId}
                apiOffices={apiOffices}
                setCurrentDate={onDateChange}
                agendaTypes={agendaTypes}
                cachedEventFilter={agendaEventFilter}
                viewSettingFilter={settingFilter}
                setDateRange={setDateRange}
                agenda={agendaFilter}
                isLoading={isLoading}
                isFetching={isFetching}
                error={error}
                selectedOwnerId={selectedOwnerId}
                isStaff={isStaff}
                isEnterpriseFilterActive={effectiveEnterpriseFilter}
                canShowOfficeName={canShowOfficeName}
              />
            )}
            {agendaViewSelected === "2" && (
              <WeeklyListView
                currentDate={currentDate}
                selectedOwnerId={selectedOwnerId}
                currentUserId={currentUserId}
                apiOffices={apiOffices}
                agendaTypes={agendaTypes}
                cachedEventFilter={agendaEventFilter}
                viewSettingFilter={settingFilter}
                searchValue=""
                isEnterpriseFilterActive={effectiveEnterpriseFilter}
                isFreeStotLoading={isLoading || isFetching}
                canShowOfficeName={canShowOfficeName}
                onDateChange={onDateChange}
                agenda={agendaFilter}
                isLoading={isLoading}
                isFetching={isFetching}
                error={error}
                setDateRange={setDateRange}
                isStaff={isStaff}
                isFromDashBoard={isFromDashBoard}
              />
            )}

            {agendaViewSelected === "3" && (
              <AgendaMonthView
                currentDate={currentDate}
                setCurrentDate={onDateChange}
                currentUserId={currentUserId}
                viewSettingFilter={settingFilter}
                setDateRange={setDateRange}
                agenda={agendaFilter}
                isLoading={isLoading}
                isFetching={isFetching}
                error={error}
                selectedOwnerId={selectedOwnerId}
                isStaff={isStaff}
                isFromDashBoard={isFromDashBoard}
                isEnterpriseFilterActive={effectiveEnterpriseFilter}
                canShowOfficeName={canShowOfficeName}
              />
            )}

            {agendaViewSelected === "1" && (
              <DailyListView
                currentDate={currentDate}
                selectedOwnerId={selectedOwnerId}
                currentUserId={currentUserId}
                apiOffices={apiOffices}
                agendaTypes={agendaTypes}
                cachedEventFilter={agendaEventFilter}
                viewSettingFilter={settingFilter}
                searchValue=""
                isEnterpriseFilterActive={effectiveEnterpriseFilter}
                isFreeStotLoading={isLoading || isFetching}
                canShowOfficeName={canShowOfficeName}
                onDateChange={onDateChange}
                agenda={agendaFilter}
                isLoading={isLoading}
                isFetching={isFetching}
                error={error}
                setDateRange={setDateRange}
                isStaff={isStaff}
                isFromDashBoard={isFromDashBoard}
              />
            )}

            {agendaViewSelected === "5" && (
              <AgendaWeeklyView
                isSidebarActive={isSidebarActive}
                currentDate={currentDate}
                isWeekly={agendaViewSelected === "5"}
                currentUserId={currentUserId}
                viewSettingFilter={settingFilter}
                setDateRange={setDateRange}
                agenda={agendaFilter}
                isLoading={isLoading}
                isFetching={isFetching}
                error={error}
                selectedOwnerId={selectedOwnerId}
                isStaff={isStaff}
                isEnterpriseFilterActive={effectiveEnterpriseFilter}
                canShowOfficeName={canShowOfficeName}
              />
            )}
          </>
        )}

        <CustomModal
          isOpen={toolTipModal}
          setIsOpen={setToolTipModal}
          title={t("accountOwner.syncModalTitle")}
          subTitle1={syncCalenderText}
          calender={true}
        />
        <SyncModal
          isOpen={syncModal}
          setIsOpen={setSyncModal}
          title={t("accountOwner.syncModalTitle")}
          syncUrl={syncUrl}
        />
      </div>
    </div>
  );
}

export default withTranslation()(AgendaTab);
